import React, { useEffect, useState } from "react";
import {
  Table,
  Typography,
  Button,
  Input,
  Row,
  Col,
  Card,
  Modal,
  Form,
  Select,
  DatePicker,
  Upload,
} from "antd";
import {
  UploadOutlined,
  EyeOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;
const { Search } = Input;
const { Option } = Select;

const NoticeBoard = () => {
  const [notices, setNotices] = useState([]);
  const [filteredNotices, setFilteredNotices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [form] = Form.useForm();
  const navigate = useNavigate();

  // ✅ FETCH DATA
  const fetchNotices = async () => {
    setLoading(true);
    try {
      const res = await axios.get("https://rhrmapi.up2dateinc.com/api/notices");
      setNotices(res.data);
      setFilteredNotices(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchNotices();
  }, []);

  // ✅ ADD NOTICE WITH FILE
  const handleAddNotice = async (values) => {
    try {
      const formData = new FormData();

      formData.append("type", values.type);
      formData.append("description", values.description);
      formData.append("date", values.date.format("YYYY-MM-DD"));
      formData.append("by", values.by);

      if (values.attachment && values.attachment.fileList.length > 0) {
        formData.append(
          "file",
          values.attachment.fileList[0].originFileObj
        );
      }

      await axios.post("https://rhrmapi.up2dateinc.com/api/notices", formData);

      form.resetFields();
      setIsModalOpen(false);
      fetchNotices();
    } catch (err) {
      console.error(err);
    }
  };

  // ✅ SEARCH
  const handleSearch = (value) => {
    const filtered = notices.filter(
      (n) =>
        n.type?.toLowerCase().includes(value.toLowerCase()) ||
        n.description?.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredNotices(filtered);
  };

  // ✅ TABLE COLUMNS
  const columns = [
    {
      title: "SL No",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Notice Type",
      dataIndex: "type",
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "Notice Date",
      dataIndex: "date",
    },
    {
      title: "Notice By",
      dataIndex: "by",
    },
    {
      title: "Action",
      render: (record) => (
        <>
          {/* 👁 VIEW */}
          <EyeOutlined
            style={{ marginRight: 15, cursor: "pointer" }}
            onClick={() =>
              navigate(`/admin/notice-details/${record._id}`)
            }
          />

          {/* ⬇ DOWNLOAD */}
          {record.file && (
            <DownloadOutlined
              style={{ cursor: "pointer" }}
              onClick={() =>
                window.open(
                  `https://rhrmapi.up2dateinc.com/uploads/${record.file}`
                )
              }
            />
          )}
        </>
      ),
    },
  ];

  return (
    <div>
      <Title level={2}>Notice Board</Title>

      {/* 🔥 TOP BAR */}
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        
        {/* LEFT - SEARCH */}
        <Col>
          <Search
            placeholder="Search..."
            onSearch={handleSearch}
            style={{ width: 250 }}
          />
        </Col>

        {/* RIGHT - BUTTONS */}
        <Col>
          <Button
            type="primary"
            onClick={() => setIsModalOpen(true)}
          >
            Add Notice
          </Button>

          <Button
            style={{ marginLeft: 10 }}
            onClick={() => navigate("/admin/manage-notice")}
          >
            Manage Notice
          </Button>
        </Col>

      </Row>

      {/* TABLE */}
      <Card>
        <Table
          dataSource={filteredNotices}
          columns={columns}
          loading={loading}
          rowKey="_id"
        />
      </Card>

      {/* MODAL */}
      <Modal
        title="Add Notice"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => form.submit()}
      >
        <Form form={form} layout="vertical" onFinish={handleAddNotice}>
          
          <Form.Item
            name="type"
            label="Notice Type"
            rules={[{ required: true }]}
          >
            <Select>
              <Option value="General">General</Option>
              <Option value="Holiday">Holiday</Option>
              <Option value="Reminder">Reminder</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="description"
            label="Description"
            rules={[{ required: true }]}
          >
            <Input.TextArea />
          </Form.Item>

          <Form.Item
            name="date"
            label="Notice Date"
            rules={[{ required: true }]}
          >
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>

          {/* ✅ ATTACHMENT (OPTIONAL) */}
          <Form.Item name="attachment" label="Attachment">
            <Upload beforeUpload={() => false}>
              <Button icon={<UploadOutlined />}>
                Select File
              </Button>
            </Upload>
          </Form.Item>

          <Form.Item
            name="by"
            label="Notice By"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

        </Form>
      </Modal>
    </div>
  );
};

export default NoticeBoard;